import { render, staticRenderFns } from "./canvasdash.vue?vue&type=template&id=4286ec4d&scoped=true&"
import script from "./canvasdash.vue?vue&type=script&lang=js&"
export * from "./canvasdash.vue?vue&type=script&lang=js&"
import style0 from "./canvasdash.vue?vue&type=style&index=0&id=4286ec4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286ec4d",
  null
  
)

export default component.exports